
import Vue from "vue";
import IconTextButton from "@/components/buttons/IconTextButton.vue";
import BaseButton from "@/components/buttons/BaseButton.vue";
import {HelperFunctions} from "@/scripts/Common/HelperFunctions";
import moment from "moment/moment";
import {DateFormats} from "@/scripts/Common/DateFormats";

export default Vue.extend({
  components: {
    IconTextButton,
    BaseButton
  },
  props: {
    hasNoEditRights: Boolean,
    heading: String,
  },
  data: () => ({
    isActive: false,
    isValid: false,
    startDate: "",
    endDate: "",
    isBusy: false
  }),
  computed: {
    rules() {
      return {
        required: (value: string) => !!value || this.$t("Rules.Required"),
        contractEndAfterStart: (endDate:string) =>
            endDate === ""||
            this.startDate === "" ||
            HelperFunctions.IsEndDateAfterOrEqualToStartDate(this.startDate, endDate) ||
            this.$t("Rules.ContractEndValidation", { startDate: moment(this.startDate).format(DateFormats.GERMAN_DATE)})
      };
    },
  },
  methods: {
    show: function(){
      this.isActive = true;
    },
    hide: function (){
      this.isActive = false;
    },
    cancel: function (){
      this.hide();
      this.$emit("canceled");
    },
    confirm: function (){
      this.hide();
      this.$emit("confirmed", { startDate: this.startDate, endDate: this.endDate });
    },
    validateDialogForm(){
      (this.$refs.dialogForm as any).validate()
    }
  },
});
